import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LogOut, User } from "lucide-react";
import Logo from "./Logo";
import { useAuth } from "../AuthContext";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const onLogout = async () => {
    await logout();
    nav("/");
  };

  const dashboardPath =
    user && user.role === "admin"
      ? "/admin"
      : user && user.role === "candidate"
        ? "/kandidaat-dashboard"
        : user && user.role === "client"
          ? "/inlener-dashboard"
          : "/login";

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-[#e2e8f0]">
      <div className="ok-container flex h-16 items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/vacatures" data-testid="nav-vacatures" className="hover:text-[#01696f] transition-colors">
            Vacatures
          </Link>
          {(!user || user === false) && (
            <>
              <Link to="/aanmelden-kandidaat" data-testid="nav-register-candidate" className="hover:text-[#01696f] transition-colors">
                Voor kandidaten
              </Link>
              <Link to="/aanmelden-inlener" data-testid="nav-register-client" className="hover:text-[#01696f] transition-colors">
                Voor inleners
              </Link>
            </>
          )}
          {user && user !== false && user.role === "candidate" && (
            <Link to="/mijn-sollicitaties" data-testid="nav-applications" className="hover:text-[#01696f] transition-colors">
              Sollicitaties
            </Link>
          )}
          {user && user !== false ? (
            <>
              <Link to={dashboardPath} data-testid="nav-dashboard"
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-sm border border-[#e2e8f0] hover:border-[#01696f]">
                <User size={14} /> Dashboard
              </Link>
              <button onClick={onLogout} data-testid="logout-btn"
                className="inline-flex items-center gap-2 text-[#4a5d5e] hover:text-[#01696f]">
                <LogOut size={14} /> Uitloggen
              </button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login"
              className="inline-flex items-center gap-2 bg-[#01696f] text-white px-4 py-2 rounded-sm hover:bg-[#015257] transition-colors">
              Inloggen
            </Link>
          )}
        </nav>
        <button data-testid="mobile-menu-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#e2e8f0] bg-white">
          <div className="ok-container py-4 flex flex-col gap-3 text-sm">
            <Link to="/vacatures" onClick={() => setOpen(false)}>Vacatures</Link>
            {(!user || user === false) && (
              <>
                <Link to="/aanmelden-kandidaat" onClick={() => setOpen(false)}>Voor kandidaten</Link>
                <Link to="/aanmelden-inlener" onClick={() => setOpen(false)}>Voor inleners</Link>
              </>
            )}
            {user && user !== false && user.role === "candidate" && (
              <Link to="/mijn-sollicitaties" onClick={() => setOpen(false)}>Sollicitaties</Link>
            )}
            {user && user !== false ? (
              <>
                <Link to={dashboardPath} onClick={() => setOpen(false)}>Dashboard</Link>
                <button onClick={() => { setOpen(false); onLogout(); }} className="text-left">Uitloggen</button>
              </>
            ) : (
              <Link to="/login" onClick={() => setOpen(false)} className="text-[#01696f] font-semibold">Inloggen</Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
